import { ReactRouterLinkWrapper } from "@/components/MenuList/ReactRouterLinkWrapper";
import {
  ImperialMetricDisplayPreference,
  WahooWorkoutType,
  WorkoutProfileResponseType,
} from "@WahooFitness/cloud-client-types";
import {
  MenuListItemVariant,
  SettingsOption,
  WorkoutProfileSettingsSection,
} from "@WahooFitness/redesignr";
import { useUserContext } from "@WahooFitness/wahoo-offline-mfe";
import { t } from "@lingui/macro";
import React, { useMemo } from "react";
import useEditWorkoutProfile from "./useEditWorkoutProfile";
import { useLingui } from "@lingui/react";
import { WSMWorkoutProfile } from "@WahooFitness/wsm-native/dist/esm/types/workout_profile";

interface Props {
  profile?: WSMWorkoutProfile;
  containedInDialog?: boolean;
  hasElemntPaired?: boolean;
}

const WorkoutSettingsSection: React.FC<Props> = ({
  profile,
  containedInDialog,
  hasElemntPaired = false,
}) => {
  const { currentUser } = useUserContext();
  const { handleFieldsChange } = useEditWorkoutProfile(profile);
  const distanceUnit =
    currentUser?.display_preference?.speed_distance ?? ImperialMetricDisplayPreference.metric;

  const workoutProfileSettingsOptions = useMemo(
    () => ({
      [SettingsOption.COUNTDOWN]: () => true,
      [SettingsOption.AUTO_PAUSE]: (profile: WorkoutProfileResponseType) =>
        profile.workout_type_family_id !== 9,
      [SettingsOption.AUTO_LAP]: (profile: WorkoutProfileResponseType) =>
        profile.workout_type_id === undefined ||
        ![WahooWorkoutType.SwimmingLap].includes(profile.workout_type_id),
      [SettingsOption.GPS_ENABLED]: (profile: WorkoutProfileResponseType) =>
        profile.workout_type_location_id !== 0,
    }),
    []
  );

  const { i18n } = useLingui();

  if (!profile) {
    return null;
  }

  return (
    <WorkoutProfileSettingsSection
      initialWorkoutProfileSettingsConfig={profile}
      onFieldsChange={handleFieldsChange}
      userDistanceDisplayPreference={distanceUnit}
      workoutProfileSettingsOptions={workoutProfileSettingsOptions}
      i18nContext={i18n}
      // TODO: Clicking alerts doesn't work when contained in a dialog.
      alertsConfigVariant={
        containedInDialog ? MenuListItemVariant.Action : MenuListItemVariant.InternalLink
      }
      alertsConfigPath={`/workout-profiles/${profile.external_id}/alerts`}
      linkComponent={ReactRouterLinkWrapper}
      hasElemntPaired={hasElemntPaired}
      title={hasElemntPaired ? t`Recording` : undefined}
      variant="elevation"
    />
  );
};

export default WorkoutSettingsSection;
